const dogBreeders = () => {
    const existingBreeders = [];

    [].slice.call(document.querySelectorAll('[data-breeder]')).forEach((breeder, iteration) => {
        existingBreeders.push({
            id: iteration,
            value: breeder.value,
            title: breeder.dataset.breeder,
            firstName: '',
            lastName: '',
            name: 'id'
        });
    });

    return {
        showInput: false,
        showLastNameValidation: false,
        hasError: false,
        dogBreeders: existingBreeders,
        breedersTitle: '',
        breedersFirstName: '',
        breedersLastName: '',
        breedersId: existingBreeders.length,

        addBreeder(event) {
            event.preventDefault();

            this.showLastNameValidation = false;
            this.hasError = false;

            if (
                this.breedersTitle.trim() === '' &&
                this.breedersFirstName.trim() === '' &&
                this.breedersLastName.trim() === ''
            ) {
                return;
            }

            if (this.breedersLastName.trim() === '') {
                this.showLastNameValidation = true;
                this.hasError = true;
            }

            if (this.hasError) {
                this.showInput = true;
                return;
            }

            this.dogBreeders.push({
                id: this.breedersId,
                value: this.breedersTitle,
                title: this.breedersTitle,
                firstName: this.breedersFirstName,
                lastName: this.breedersLastName,
                ownerId: null,
                name: 'title'
            });

            this.breedersId += 1;
            this.breedersTitle = '';
            this.breedersFirstName = '';
            this.breedersLastName = '';
        },

        deleteBreeder(id, event, originalOwners) {
            const currentInputValue = event.target.previousElementSibling.value;

            [].slice.call(document.querySelectorAll('input')).forEach((input) => {
                if (input.value === currentInputValue) {
                    if (input.hasAttribute('data-breeder')) {
                        input.remove();
                    }
                }
            });

            this.dogBreeders = this.dogBreeders.filter((breeder) => id !== breeder.id);

            // If any owner isn't included in the breeders list, enable the button
            let disableOwnersButton = true;
            originalOwners.forEach((owner) => {
                if (! this.ownerExistsInBreedersArray(owner)) {
                    disableOwnersButton = false;
                }
            });

            this.toggleIncludeOwnersButton(disableOwnersButton);
        },

        includeOwners(owners) {
            owners.forEach((owner) => {
                if (this.ownerExistsInBreedersArray(owner)) {
                    return;
                }

                if (owner.first_name.trim() !== '' && owner.last_name.trim() !== '') {
                    this.dogBreeders.push({
                        id: this.breedersId,
                        value: owner.title,
                        title: owner.title,
                        firstName: owner.first_name,
                        lastName: owner.last_name,
                        ownerId: owner.owner_id,
                        name: 'title'
                    });

                    this.breedersId += 1;
                }

                this.toggleIncludeOwnersButton(true);
            });
        },

        ownerExistsInBreedersArray(owner) {
            // Match 2 lowercase, spaceless strings containing the full names of the owner and breeder
            const existingOwners = this.dogBreeders.filter(function(existingBreeder) {
               let ownerNames = [owner.title, owner.first_name, owner.last_name];
               let ownerFullName = ''.concat(...ownerNames).replace(/\s/g, '').toLowerCase();

               // The full name on an existing breeder can be added as 'title'
               let breederTitle = existingBreeder.title.replace(/\s/g, '').toLowerCase();

               let breederNames = [breederTitle, existingBreeder.firstName, existingBreeder.lastName];
               let breederFullName = ''.concat(...breederNames).replace(/\s/g, '').toLowerCase();

               return ownerFullName === breederFullName || ownerFullName === breederTitle;
            });

            return existingOwners.length > 0;
        },

        toggleIncludeOwnersButton(disable) {
            const includeOwnersButton = document.querySelector('#includeOwnersButton');

            if (disable) {
                includeOwnersButton.classList.add('btn--disabled');
                includeOwnersButton.disabled = true;
                includeOwnersButton.setAttribute('aria-disabled', 'true');

                return;
            }

            includeOwnersButton.classList.remove('btn--disabled');
            includeOwnersButton.disabled = false;
            includeOwnersButton.setAttribute('aria-disabled', 'false');
        },

        submitForm() {
            const form = document.querySelector('[data-step-breeders]');

            if (form) {
                form.submit();
            }
        }
    };
};

export default function breeders() {
    window.dogBreeders = dogBreeders;
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/dogBreeders.js